import React from 'react';
import ReactFlow, { PanOnScrollMode } from 'reactflow';
import { useAuthStore } from '../../../store/storeAuth';
import { Box } from '@mui/material';
import { formNodeTypes } from '../../../util/nodeTypes';
import Cursors from '../Collaborative/Cursors';
import useCursorStateSynced from '../Collaborative/useCursorStateSynced';
import HelperLinesRenderer from './HelperLines';

const FormBuilderFlow = ({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  updateNodeEdge,
  setUpdateNodeEdge,
  onDragOver,
  onDrop,
  setReactFlowInstance,
  customApplyNodeChanges,
  helperLineHorizontal,
  helperLineVertical,
}: any) => {
  const user = useAuthStore(state => state.user);
  // const [cursors, onMouseMove] = useCursorStateSynced();

  const theme = user?.theme;
  return (
    <ReactFlow
      style={{
        background: theme === 'dark' ? '#475467' : '#E7F0FF',
        borderRadius: '8px',
      }}
      className={theme === 'dark' ? 'dark-theme' : 'light-theme'}
      nodes={nodes}
      onNodesChange={onNodesChange}
      snapToGrid
      nodeTypes={formNodeTypes as any}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onInit={setReactFlowInstance}
      proOptions={{ account: 'paid-pro', hideAttribution: true }}
      fitView //   edgeTypes={edgeTypes as any}Learn more about JS/TS refactorings
      maxZoom={1}
      minZoom={0.3}
      // onPointerMove={onMouseMove}
      // panOnScroll={true}
      // panOnScrollMode={PanOnScrollMode.Vertical}
      // panOnDrag={false}

      // background fixed
    >
      <HelperLinesRenderer
        horizontal={helperLineHorizontal}
        vertical={helperLineVertical}
      />
    </ReactFlow>
  );
};

export default FormBuilderFlow;
